import { img } from '../../assets/assets'
import { IUser } from '../../types/user'
import { useTypedSelector } from '../../hooks/useTypedSelector'
import { Link } from 'react-router-dom'
import { useEffect, useMemo, useState } from 'react'
import { getUserAvatar, getUserBackground } from '../../utils/methods'
import { getUserName } from '../../utils/methods'
import { Button } from '../UI/Buttons'
import { Donation } from '../Donation'
import { FollowButton, Following } from './Following'
import { Container } from '../Container'

interface IProps {
    user: IUser
}

export const Profile = ({ user }: IProps) => {
    const social = useMemo(
        () => [
            {
                show: user.socialTwitter,
                url: user.socialTwitter,
                icon: img.icons_twitter,
                name: 'Twitter',
            },
            {
                show: user.socialTwitch,
                url: user.socialTwitch,
                icon: img.twitch,
                name: 'Twitch',
            },
            {
                show: user.socialOnlyfans,
                url: user.socialOnlyfans,
                icon: img.icons_onlyfans,
                name: 'OnlyFans',
            },
            {
                show: user.socialInstagram,
                url: user.socialInstagram,
                icon: img.icons_instagram,
                name: 'Instagram',
            },
        ],
        [user]
    )
    const { auth } = useTypedSelector((s) => s)
    const [showDonation, setShowDonation] = useState(false)
    const [showFollowing, setShowFollowing] = useState(false)
    const showSocios = useMemo(
        () => !!social.filter((s) => s.show).length,
        [social]
    )

    const showButtons = useMemo(
        () => !!auth.id.length && auth.id !== user.id,
        [user, auth]
    )

    useEffect(() => {
        setShowDonation(false)
        setShowFollowing(false)
    }, [user])

    return (
        <>
            <section className="profile">
                <div className="profile__header">
                    <img src={getUserBackground(user.background)} alt="" />
                </div>
                <Container>
                    <div className="profile__main">
                        <div className="profile__left">
                            <div className="profile__avatar">
                                <img
                                    src={getUserAvatar(user.avatar)}
                                    alt="avatar"
                                />
                            </div>
                            <div className="profile__name">
                                {getUserName(user)}
                            </div>
                            {user.metaName && (
                                <div className="profile__metaname">
                                    @{user.metaName}
                                </div>
                            )}
                            {showSocios && (
                                <div className="profile__socio socio">
                                    {social.map((s) =>
                                        s.show ? (
                                            <a
                                                className="socio__item"
                                                href={s.url}
                                                key={s.name}
                                            >
                                                <img
                                                    src={s.icon}
                                                    alt={s.name}
                                                />
                                                <span>{s.name}</span>
                                            </a>
                                        ) : null
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="profile__right">
                            <div className="profile__actions">
                                <div className="following">
                                    <div
                                        className="following__block following__block-pointer"
                                        onClick={() => setShowFollowing(true)}
                                    >
                                        <div className="following__count">
                                            {user.followingsCount || 0}
                                        </div>
                                        <div className="following__title">
                                            Following
                                        </div>
                                    </div>
                                    <div
                                        className="following__block  following__block-pointer"
                                        onClick={() => setShowFollowing(true)}
                                    >
                                        <div className="following__count">
                                            {user.followersCount || 0}
                                        </div>
                                        <div className="following__title">
                                            Followers
                                        </div>
                                    </div>
                                    {showButtons && (
                                        <>
                                            <div className="following__block">
                                                <FollowButton
                                                    user={user}
                                                    className="following__button"
                                                ></FollowButton>
                                            </div>
                                            <div className="following__block">
                                                <Button
                                                    stylePreset="semitransparent"
                                                    onClick={() =>
                                                        setShowDonation(true)
                                                    }
                                                    className="following__button"
                                                >
                                                    Donate
                                                </Button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            {!!user.description.length && (
                                <>
                                    <div className="profile__title">BIO</div>
                                    <pre className="profile__description">
                                        {user.description}
                                    </pre>
                                </>
                            )}
                        </div>
                    </div>
                </Container>

                {showButtons && (
                    <Donation
                        showState={[showDonation, setShowDonation]}
                        user={user}
                    ></Donation>
                )}
                <Following
                    showState={[showFollowing, setShowFollowing]}
                    user={user}
                ></Following>
            </section>
        </>
    )
}

interface IPropsUsername {
    user?: IUser
    className?: string | undefined
    isLink?: boolean
}

export const Username = ({ user, className, isLink }: IPropsUsername) => {
    return (
        <>
            {user ? (
                isLink ? (
                    <Link
                        to={`/user/${user.id}`}
                        className={`username ${className || ''}`}
                    >
                        {user.metaName ? `@${user.metaName}` : ''}
                    </Link>
                ) : (
                    <div className={`username ${className || ''}`}>
                        {user.metaName ? `@${user.metaName}` : ''}
                    </div>
                )
            ) : null}
        </>
    )
}
